<template>
    <main-layout>
        <v-container class="fill-height align-start" fluid>
            <v-card min-width="400">
                <v-card-text>
                    <v-text-field label="아이디" v-model="form.userid" :disabled="!!form._id"/>
                    <v-text-field label="비밀번호" type="password" v-model="form.userpw" :disabled="!!form._id"/>
                    <v-text-field label="이름" v-model="form.name" />
                    <v-select label="역할" v-model="form.role" :items="roles"/>
                    <v-alert v-if="!!message" type="error">
                        {{message}}
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-btn v-if="form._id === null" tile block large @click="submitForm">추가</v-btn>
                    <template v-else>
                        <v-btn tile large @click="resetForm">리셋</v-btn>
                        <v-spacer/>
                        <v-btn tile large @click="submitForm">업데이트</v-btn>
                    </template>
                </v-card-actions>
            </v-card>

            <div class="d-flex flex-grow-1 ml-5 white--text">
                <v-data-table
                    :headers="headers"
                    :items="users"
                    :items-per-page="5"
                    :loading="loading"
                    class="elevation-1"
                    dense>
                    <template v-slot:[`item.role`]="{item}">
                        {{getRoleName(item.role)}}
                    </template>
                    <template v-slot:[`item.action`]="{item}">
                        <v-btn tile text @click="setForm(item)">수정</v-btn>
                        <v-btn tile text @click="submitDelete(item)">삭제</v-btn>
                    </template>
                </v-data-table>
            </div>
            
        </v-container>
    </main-layout>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
export default {
    methods: {
        async submitForm () {
            let resp = {result: 'ERR', error: 'initial'}
            let postData = JSON.parse(JSON.stringify(this.form))
            let _id = postData._id
            delete postData._id
            
            try {
                if (_id) resp = await axios.put('/api.user/' + _id, postData)
                else resp = await axios.post('/api.user', postData)
                
                if (resp.data.result === 'ERR') return (this.message = resp.data.error)
                this.resetForm()
                this.loadList()
            }
            catch (err) {
                console.error(err)
                this.message = err.message
            }
        },
        async submitDelete (data) {
            await axios.delete('/api.user/' + data._id)
            this.loadList()
        },
        async loadList () {
            this.loading = true
            let resp = await axios.get('/api.user')
            this.users = resp.data
            this.loading = false
        },
        setForm (data) {
            if (data._id) this.form._id = data._id
            if (data.userid) this.form.userid = data.userid
            if (data.userpw) this.form.userpw = data.userpw
            if (data.name) this.form.name = data.name
            if (data.role) this.form.role = data.role
        },
        resetForm () {
            this.form._id = null
            this.form.userid = ''
            this.form.userpw = ''
            this.form.name = ''
            this.form.role = null
        },
        getRoleName (role) {
            let r = _.find(this.roles,  {value: role})
            if (!r) return 'ERR'
            return r.text
        }
    },
    mounted () {
        this.loadList()
    },
    data () {
        return {
            form: {
                _id: null,
                userid: '',
                userpw: '',
                name: '',
                role: null
            },
            roles: [
                {text: '의료진', value: 'PH'},
                {text: '환자', value: 'PA'}
            ],
            users: [],
            message: null,
            loading: false,
            headers: [
                { text: '역할', value: 'role' },
                { text: 'ID', value: 'userid' },
                { text: '이름', value: 'name' },
                { text: '편집', value: 'action', width: 160, align: 'center' }
            ]
        }
    }
}
</script>